import React, { Component } from 'react';
import history from './history';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  setHamburgerVisibility,
  manageSidemenu,
  initLoadingAction,
  stopInitLoadingAction,
} from 'src/Actions/Generic/genericActions';
import {
  getSubscriptionInfo,
  setSubscriptionExpiredStatus,
  setUserDetails,
} from 'src/Actions/Subscription/subscriptionAction';
import { Routes } from './Routes';
import Expired from './Containers/Expired/Expired';
import {
  getAccountStatus,
  updateAccountStatus,
} from 'src/Actions/Registration/registerActions';
import { AnalyticsService } from 'src/Analytics/AnalyticsService';
import { filterActiveStatus } from 'src/Utils/index';
import Info from './Containers/Info/Info';
import { GE_DOMAIN, NATIVE_REDIRECT } from './Config/constants';

let loginType = localStorage.getItem('loginType');

class AuthenticatedRoutes extends Component {
  state = {
    C2CExpired: false,
    bothExpired: false,
    showExpiredScreen: false,
    homePath: '',
    accountStatus: null,
    AdhocExpired: false,
  };
  componentDidMount() {
    this.props.initLoadingAction();
    if (loginType !== GE_DOMAIN) {
      this.props.getAccountStatus();
      this.props.getSubscriptionInfo();
    }

    AnalyticsService.trackEvent('login_successed');
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.registration.accountStatus !==
      this.props.registration.accountStatus
    ) {
      const status = this.props.registration.accountStatus.status;
      const { history } = this.props;
      if (
        status === 'PENDING_ACCOUNT_SETUP' ||
        status === 'PENDING_ACCOUNT_SETUP_AND_ADMIN_GRANT'
      ) {
        this.setState({
          accountStatus: this.props.registration,
        });

        history.push('/setupAccount');
      }
      if (status === 'PENDING_ADMIN_GRANT') {
        history.push('/adminAcknowledge');
      }
    }

    // Fetched the data into the store
    if (
      prevProps.subscription.subscriptionInfo !==
      this.props.subscription.subscriptionInfo
    ) {
      let digitalData;
      if (loginType.includes('SFDC')) {
        digitalData = {
          user: {
            profile: {
              profileInfo: {
                loginStatus: 'logged in',
                profileID: this.props.subscription.subscriptionInfo.sfdcUserId,
              },
            },
            userType: '',
          },
        };
      } else {
        digitalData = {
          user: {
            profile: {
              profileInfo: {
                loginStatus: 'logged in',
                profileID: '',
              },
            },
            userType: loginType,
          },
        };
      }
      AnalyticsService.updateDigitalData(digitalData);
      AnalyticsService.trackEvent('setAnalyticsVariables');

      if (
        this.props.subscription.subscriptionInfo &&
        Object.keys(this.props.subscription.subscriptionInfo).length > 0
      ) {
        this.setExpirationStatus();
        this.setMenuItems();
      }
    }
  }

  /**
   *
   * @param {SubscriptionInfo} subscriptionInfo (OBJECT)
   * @returns Boolean, if the subscription is expired or not
   */

  // Only one activation key is handles here
  handleSingleSubscription = (userSubscriptionInfo) => {
    let C2CExpired = false,
      AdhocExpired = false;
    if (userSubscriptionInfo.subscriptionStatus.isCollaborationSubscription) {
      C2CExpired =
        userSubscriptionInfo.subscriptionStatus.collabSubscriptionStatus ===
          'EXPIRED'
          ? true
          : false;
    }
    if (userSubscriptionInfo.subscriptionStatus.isAdhocSubscription) {
      AdhocExpired =
        userSubscriptionInfo.subscriptionStatus.adhocSubscriptionStatus ===
          'EXPIRED'
          ? true
          : false;
    }

    return { C2CExpired, AdhocExpired };
  };

  /**
   *
   * @param {complete array of subscriptionInfo} userSubscriptionInfoArray
   * @returns boolean key/value paired object telling EDUCATION and COLLABORATION is present or not
   */
  // Helper for multi
  getEduCollInfo = (userSubscriptionInfoArray) => {
    let isCollaborationPresent = false,
      isAdhocPresent = false;
    let collaborationList = [];
    let adhocList = [];
    if(userSubscriptionInfoArray != null){
      userSubscriptionInfoArray.forEach((obj) => {
        collaborationList = collaborationList.concat(
          obj.subscriptionStatus.isCollaborationSubscription
        );
        adhocList = adhocList.concat(
          obj.subscriptionStatus.isAdhocSubscription
        );
      });
    }
    if (collaborationList && collaborationList.length > 0) {
      if (collaborationList.includes(true)) {
        isCollaborationPresent = true;
      }
    }
    if (adhocList && adhocList.length > 0) {
      if (adhocList.includes(true)) {
        isAdhocPresent = true;
      }
    }

    return { isCollaborationPresent, isAdhocPresent };
  };

  filterValues = (userSubscriptionInfoArray) => {
    let collaborationList1 = [];
    let adhocList1 = [];
    if(userSubscriptionInfoArray != null){
      userSubscriptionInfoArray.map((i) => {
        collaborationList1 = collaborationList1.concat(
          i.subscriptionStatus.collabSubscriptionStatus
        );
        adhocList1 = adhocList1.concat(
          i.subscriptionStatus.adhocSubscriptionStatus
        );
      });
    }
    let formattedCollabList =
      collaborationList1 && collaborationList1.length > 0
        ? collaborationList1.filter((i) => i !== null)
        : [];
    let formattedAdhocList =
      adhocList1 && adhocList1.length > 0
        ? adhocList1.filter((i) => i !== null)
        : [];

    return { formattedCollabList, formattedAdhocList };
  };

  handleMultipleSubscriptions = (userSubscriptionInfoArray) => {
    let C2CExpired = false,
      AdhocExpired = false;
    const { isCollaborationPresent, isAdhocPresent } = this.getEduCollInfo(
      userSubscriptionInfoArray
    );
    // Only Collaboration is Present
    if (isCollaborationPresent && !isAdhocPresent) {
      C2CExpired = this.validateCollabSub(userSubscriptionInfoArray, true);
    }
    //Only Adhoc is Present
    else if (isAdhocPresent && !isCollaborationPresent) {
      AdhocExpired = this.validateAdhocSub(userSubscriptionInfoArray);
    }
    //When more than one configuration is present
    else {
      if (isAdhocPresent) {
        AdhocExpired = this.validateAdhocSub(userSubscriptionInfoArray);
      }
      if (isCollaborationPresent) {
        C2CExpired = this.validateCollabSub(userSubscriptionInfoArray, false);
      }
    }
    return { C2CExpired, AdhocExpired };
  };

  validateCollabSub = (userSubscriptionInfoArray, collabOnly) => {
    let { formattedCollabList } = this.filterValues(
      userSubscriptionInfoArray
    );
    if (collabOnly) {
      return (formattedCollabList && formattedCollabList.length > 0 &&
        formattedCollabList.includes('EXPIRED')
        ? true
        : false);
    }
    else {
      return (formattedCollabList &&
        formattedCollabList.length > 0 &&
        formattedCollabList.every((v) => v === 'EXPIRED')
        ? true
        : false);
    }
  };

  validateAdhocSub = (userSubscriptionInfoArray) => {
    let { formattedAdhocList } = this.filterValues(
      userSubscriptionInfoArray
    );
    return (formattedAdhocList &&
      formattedAdhocList.length > 0 &&
      formattedAdhocList.every((v) => v === 'EXPIRED')
      ? true
      : false);
  };

  getEntRoles = () => {
    let entRoles = [];
    const { subscriptionInfo } = this.props.subscription;
    const { userSubscriptionInfo } = subscriptionInfo;
    if (userSubscriptionInfo && userSubscriptionInfo.length === 1) {
      if (
        userSubscriptionInfo[0].entRoles &&
        userSubscriptionInfo[0].entRoles.length > 0
      ) {
        userSubscriptionInfo[0].entRoles.forEach((i) => {
          if (i.isActive) {
            entRoles = entRoles.concat(i.role);
          }
        });
      }
    } else {
      entRoles = this.setUserRoles(userSubscriptionInfo);
    }
    return entRoles;
  };

  setMenuItems = () => {
    const { subscriptionInfo } = this.props.subscription;
    const { userSubscriptionInfo } = subscriptionInfo;
    let isCollaborationAvailable = false;
    let isAdhocAvailable = false;
    let isCollaborationActive = false;
    let isAdhocActive = false;
    let entRoles = [];
    if (userSubscriptionInfo?.length === 1) {
      isCollaborationAvailable =
        userSubscriptionInfo[0].subscriptionStatus.isCollaborationSubscription;
      isAdhocAvailable =
        userSubscriptionInfo[0].subscriptionStatus.isAdhocSubscription;
    } else {
      let { formattedCollabList, formattedAdhocList } =
        this.setSubscriptionDetails(userSubscriptionInfo);
      if (formattedCollabList?.length > 0) isCollaborationAvailable = true;
      if (formattedAdhocList?.length > 0) isAdhocAvailable = true;
    }
    let { formattedActiveCollabList, formattedActiveAdhocList } =
      filterActiveStatus(userSubscriptionInfo);
    if (formattedActiveCollabList?.length > 0) isCollaborationActive = true;
    if (formattedActiveAdhocList?.length > 0) isAdhocActive = true;

    entRoles = this.getEntRoles();

    let homePath = this.setHomePath(
      isCollaborationActive,
      isAdhocActive,
      entRoles
    );
    this.setState({
      homePath,
    });
    this.props.setUserDetails(
      isCollaborationAvailable,
      isAdhocAvailable,
      {
        isCollaborationActive,
        isAdhocActive
      },
      entRoles,
      homePath
    );

  };

  getAdminHomepath = (isCollabActive) => {
    if (isCollabActive) {
      return '/people';
    }
    else {
      return '/info';
    }
  }

  getTrainerHomepath = (isCollabActive, entRoles) => {
    if (isCollabActive && entRoles.includes('TRAINER')) {
      return '/account';
    }
    else if (isCollabActive && !entRoles.includes('TRAINER')) {
      return '/account';
    }
    else {
      return '/info';
    }
  }

  getAdhocInactiveHomepath = (isCollabActive, entRoles) => {
    if (!(isCollabActive)) {
      return '/info';
    }
    else if (entRoles.includes('ADMIN')) {
      return '/people';
    }
    else {
      return '/account';
    }
  }

  setHomePath = (isCollabActive, isAdhocActive, entRoles) => {

    let homePath = '';
    const nativeRedirectComponent = window.localStorage.getItem(NATIVE_REDIRECT);
    if (!!nativeRedirectComponent) {
      homePath = nativeRedirectComponent;
      window.localStorage.removeItem(NATIVE_REDIRECT);
      return homePath;
    }
    if (isAdhocActive) {
      if (entRoles.includes('ADMIN')) {
        homePath = this.getAdminHomepath(isCollabActive);
      }

      else {
        homePath = this.getTrainerHomepath(isCollabActive, entRoles);
      }
    }
    else {
      console.log("adhocinactive");
      homePath = this.getAdhocInactiveHomepath(isCollabActive, entRoles);
    }
    console.log(homePath)
    return homePath;

  };

  setUserRoles = (list) => {
    let entRoles = [];
    let completeList = list.map((i) => {
      return i.entRoles;
    });
    let rolesList = [].concat.apply([], completeList);
    rolesList.forEach((obj) => {
      if (obj.isActive) {
        entRoles = entRoles.concat(obj.role);
      }
    });
    let uniqList = entRoles.filter((i, index) => entRoles.indexOf(i) === index); //NOSONAR
    return uniqList;
  };

  setSubscriptionDetails = (list) => {
    let { formattedCollabList, formattedAdhocList } = this.filterValues(list);
    return { formattedCollabList, formattedAdhocList };
  };

  // Driver Fn
  setExpirationStatus = () => {
    const { subscriptionInfo } = this.props.subscription;
    // Type: Array
    const { userSubscriptionInfo } = subscriptionInfo;
    let expiryResult;
    let isSingleSubs = true;
    // Single subscription (only 1 activation key)
    if (userSubscriptionInfo && userSubscriptionInfo.length === 1) {
      expiryResult = this.handleSingleSubscription(userSubscriptionInfo[0]);
    } else {
      expiryResult = this.handleMultipleSubscriptions(userSubscriptionInfo);
      isSingleSubs = false;
    }
    let { C2CExpired = false, AdhocExpired = false } = expiryResult;
    const isTruthy = (val) => {
      if (val) return val;
    };
    let showExpiredScreen = [C2CExpired, AdhocExpired].some(isTruthy);
    this.props.setSubscriptionExpiredStatus(
      C2CExpired,
      AdhocExpired,
      isSingleSubs
    );
    // Finally set the state
    this.setState({
      C2CExpired,
      AdhocExpired,
      bothExpired: C2CExpired,
      showExpiredScreen,
    });
  };

  renderRoute = () => {
    let { isSideMenuHidden, initialLoad } = this.props.generic;
    let { accountStatus } = this.props.registration;
    let { homePath } = this.state;
    const menuWrapperProps = {
      manageSidemenu: this.props.manageSidemenu,
      setHamburgerVisibility: this.props.setHamburgerVisibility,
      isMenuVisible: !isSideMenuHidden,
    };
    if (accountStatus)
      return (
        <Routes
          menuWrapperProps={menuWrapperProps}
          history={history}
          homePath={homePath}
          subscriptions={this.props.subscription}
          stopInitLoading={this.props.stopInitLoadingAction}
          initLoading={initialLoad}
        />
      )
    else if (this.props.subscription.noSubscriptionActive)
      return (
        <div className="unauth-expired-screen">
          <Info />
        </div>
      )
    else
      return (
        <>
          {this.props.subscription.isForbidden && !this.props.generic.loading && (
            <div className="unauth-expired-screen">
              <Expired unAuth={true} />
            </div>
          )}
        </>
      )
  }

  renderContent = () => {
    let { isSideMenuHidden, initialLoad } = this.props.generic;
    let { homePath } = this.state;
    const menuWrapperProps = {
      manageSidemenu: this.props.manageSidemenu,
      setHamburgerVisibility: this.props.setHamburgerVisibility,
      isMenuVisible: !isSideMenuHidden,
    };
    if (loginType !== GE_DOMAIN) return this.renderRoute();
    else if (!this.props.subscription.isForbidden) {
      return (<Routes
        menuWrapperProps={menuWrapperProps}
        history={history}
        homePath={homePath}
        stopInitLoading={this.props.stopInitLoadingAction}
        initLoading={initialLoad}
      />)
    } else {
      return (<>
        <div className="unauth-expired-screen">
          <Expired unAuth={true} />
        </div>
      </>)
    }
  }

  render() {
    return (
      <>
        {this.renderContent()}
      </>
    );
  }
}

export const mapStateToProps = ({
  generic,
  subscription,
  collab,
  chat,
  registration,
}) => ({
  generic,
  subscription,
  collab,
  chat,
  registration,
});

export const mapDispatchToProps = (dispatch) => ({
  initLoadingAction: () => dispatch(initLoadingAction()),
  stopInitLoadingAction: () => dispatch(stopInitLoadingAction()),
  setHamburgerVisibility: (visible) =>
    dispatch(setHamburgerVisibility(visible)),
  getSubscriptionInfo: () => dispatch(getSubscriptionInfo()),
  manageSidemenu: (val) => dispatch(manageSidemenu(val)),
  setSubscriptionExpiredStatus: (c2c, adhoc, isSingleSubs) =>
    dispatch(setSubscriptionExpiredStatus(c2c, adhoc, isSingleSubs)),
  setUserDetails: (a, b, adhoc, activeConfigList, c, d) => dispatch(setUserDetails(a, b, adhoc, activeConfigList, c, d)),
  getAccountStatus: () => dispatch(getAccountStatus()),
  updateAccountStatus: (accountStatus) => dispatch(updateAccountStatus()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(AuthenticatedRoutes));
